import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { FormsHubListComponent } from '@modules/forms/components/forms-hub-list.component';
import { FormsListContextMenuDirective } from '@modules/forms/directives/forms-list-context-menu.directive';
import { FormsKpListStateService } from '@modules/forms/services/forms-kp-list-state.service';
import { FormStitchFilters, FormsStitchService } from '@modules/forms/services/forms.service';
import { type FormStitch } from '@modules/forms/types/form-stitch';
import { type FormsKpListState } from '@modules/forms/types/forms-kp-list-state';
import { KPResultsEmptyComponent } from '../kp-results-empty/kp-results-empty.component';
import { KpResultsHeaderComponent } from '../kp-results-header/kp-results-header.component';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

export const FORMS_KP_SECTION_IMPORTS = [
  Button2Component,
  IconComponent,
  MatTooltipModule,
  KpResultsHeaderComponent,
  KPResultsEmptyComponent,
  FormsHubListComponent,
  FormsListContextMenuDirective,
];

/** Forms-specific adapter around the native KP section, list state and shared item cards. */
@Component({
  selector: 'app-knowledge-forms-section',
  standalone: true,
  templateUrl: './forms-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: FORMS_KP_SECTION_IMPORTS,
  providers: FormsKpListStateService.providers(),
})
export class KnowledgeFormsSectionComponent
  extends KnowledgeStitchSectionComponent<FormStitch, FormStitchFilters>
  implements OnInit
{
  protected readonly listStateService = inject(FormsKpListStateService, { self: true });
  protected readonly stitchService = inject(FormsStitchService);
  protected readonly folder = false;

  public override ngOnInit(): void {
    this.state = new FormStitchFilters({ withEmpty: true });
    super.ngOnInit();
  }
  public handleFilter(listState: FormsKpListState): void {
    this.filterChange.emit();
    this.filters = new FormStitchFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() }).applyListState(
      listState,
    );
    this.updateFilters();
  }
}
